<eca-pillar-box class="profile-content">
  <eca-dynamic-notification-window [notificationInputStream]="notificationSource"></eca-dynamic-notification-window>
  @if (profileForm && (validationRules$ | async); as validationRules) {
    <eca-form-column>
      <span class="logo-group">
        <eca-drc-insight-logo></eca-drc-insight-logo>
      </span>
      <form [formGroup]="profileForm" (ngSubmit)="onSubmitForm($event)" autocomplete="off" novalidate>
        <h1 class="eca-skip-link-focus-target" tabindex="-1">{{formTitle}}</h1>
        <p>{{formSubtitle}}</p>
        <ng-content select=".ng-content-before"></ng-content>
        <div class="group-form">
          <mat-form-field class="reduced-space">
            <mat-label>New Password</mat-label>
            <eca-password aria-describedby="new-password-description" [formControl]="newPassword"></eca-password>
          </mat-form-field>
          <div id="new-password-description">
            @if (!newPassword.touched && validationRules?.checks?.length) {
              <ul class="new-password-errors">
                @for (item of validationRules.checks; track item.name) {
                  <li>{{item.rule}}</li>
                }
              </ul>
            }
            @if (newPassword.touched && newPassword.value && validationRules?.checks?.length) {
              <ul class="new-password-errors validated-password">
                @for (item of validationRules.checks; track item.name) {
                  <li class="{{ item.valid === true ? 'valid-item' : 'invalid-item' }}">
                    <span [attr.aria-label]="item.valid ? 'Valid' : 'Invalid'" role="img"></span> {{item.rule}}
                  </li>
                }
              </ul>
            }
            @if (newPassword.touched && !newPassword.value && originalValidationRules?.checks?.length) {
              <ul class="new-password-errors validated-password">
                @for (item of originalValidationRules.checks; track item.name) {
                  <li class="{{ item.valid === true ? 'valid-item' : 'invalid-item' }}">
                    <span [attr.aria-label]="item.valid ? 'Valid' : 'Invalid'" role="img"></span> {{item.rule}}
                  </li>
                }
              </ul>
            }
          </div>
          <mat-form-field class="reduced-space">
            <mat-label>Confirm New Password</mat-label>
            <eca-password aria-describedby="confirm-new-password-description" [formControl]="newPasswordConfirm" required></eca-password>
          </mat-form-field>
          <div id="confirm-new-password-description">
            @if (newPasswordConfirm.touched) {
              <ul class="new-password-errors validated-password">
                @if (profileForm.hasError('passwordNotEquivalent') || newPasswordConfirm.hasError('passwordNotEquivalent') || newPasswordConfirm.hasError('required')) {
                  <li class="invalid-item">
                    <span aria-hidden="true"></span> New and confirmation passwords do not match
                  </li>
                }
                @else {
                  <li class="valid-item">
                    <span aria-hidden="true"></span> Confirmation password matches with new password
                  </li>
                }
              </ul>
            }
            @if (newPasswordConfirm.untouched) {
              <ul class="new-password-errors">
                <li>New and confirmation passwords must match</li>
              </ul>
            }
          </div>
          <div class="eca-form-column-buttons">
            <button mat-button color="primary" [disabled]="profileForm.invalid || checkStatus !== 'OK' || formDisabled"
              name="btnSubmit" type="submit">
              {{saveButtonText}}
            </button>
            @if (cancelButtonText) {
              <button mat-button (click)="onCancelClick()" type="button" name="btnCancel">
                {{cancelButtonText}}
              </button>
            }
          </div>
        </div>
        <ng-content select=".ng-content-after"></ng-content>
      </form>
    </eca-form-column>
  }
</eca-pillar-box>
